<template>
  <div
    :class="{
      show: visible,
      dropup: dropup,
      dropdown: !dropup
    }"
  >
    <slot name="toggle" />
    <div
      v-if="visible"
      :id="id"
      ref="menu"
      class="dropdown-menu show"
      :class="menuClass"
      :style="menuStyle"
      @click.stop
    >
      <slot />
    </div>
  </div>
</template>

<script>
/**
 * So...why does this exist?
 * Well it's because bootstrap-vue has a stupid ass mechanism to try and sync focus
 * with hover'd items in the dropdown (in order to be compliant with some BS ARIA thing)
 * ...well it would be cool were they to be in sync with how the bootstrap library itself
 * does styling; however it isn't, so you end up with this wierd trailing focus styling on
 * dropdown items as if it was bugged
 * more amazing explanation and dialogue here:
 *     https://github.com/bootstrap-vue/bootstrap-vue/issues/1320
 *     https://github.com/bootstrap-vue/bootstrap-vue/issues/1374
 */
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    dropup: {
      type: Boolean,
      default: false
    },
    autoAlign: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    menuClass: [String, Object],
    // eslint-disable-next-line vue/require-default-prop
    maxHeight: [String, Number]
  },
  emits: ['update:visible', 'show', 'shown', 'hide', 'hidden'],
  data() {
    return {
      marginLeft: 0,
      id: `elbootstrap-${Math.floor(Math.random() * 100)}`
    }
  },
  computed: {
    menuStyle() {
      const formatValue = val => isNaN(val) ? val : `${val}px`
      const style = {}
      if (this.maxHeight) {
        style.maxHeight = formatValue(this.maxHeight)
      }
      if (this.marginLeft) {
        style.marginLeft = formatValue(this.marginLeft)
      }
      return style
    }
  },
  watch: {
    visible() {
      this.marginLeft = 0
      this.$emit(this.visible ? 'show' : 'hide')
      this.$nextTick(() => {
        // auto-align: adjust dropdown alignment based on its position
        if (this.visible && this.autoAlign && this.$refs.menu) {
          const rect = this.$refs.menu.getBoundingClientRect()
          const windowWidth = window.innerWidth || document.documentElement.clientWidth
          if (rect.right >= windowWidth) {
            this.marginLeft = Math.round(windowWidth - rect.right)
          }
        }

        this.$emit(this.visible ? 'shown' : 'hidden')
      })
    }
  },
  mounted() {
    document.body.addEventListener('click', this.closeDropdown, true)
  }, beforeUnmount() {
    document.body.removeEventListener('click', this.closeDropdown, true)
  },
  methods: {
    closeDropdown(event) {
      if (this.visible && event.target.closest(`#${this.id}`) === null) {
        this.$emit('update:visible', false)
      }
    }
  }
}
</script>
